import React from 'react';

const Dashboard = () => {
    return (
        <>
            <div class="container d-flex flex-column justify-content-center align-items-center">
                <h2>Dashboard Page: This is Private Route</h2>
            </div>
        </>
    );
};

export default Dashboard;
